/**
 * 2-Column Feature Template
 *
 * An alternating feature layout with image on one side and content on the other.
 */

// eslint-disable-next-line no-unused-vars
const features2col = {
  id: 'features-2col',
  name: '2-Column Feature',
  category: 'features',
  description: 'Two-column feature layout with image and text content',
  thumbnail: null,
  content: {
    section_type: 'layout-1',
    sectionBackgroundColor: 'transparent',
    backgroundImage: '',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    marginTop: '0',
    marginBottom: '0',
    paddingTop: '48',
    paddingBottom: '48',
    paddingLeft: '24',
    paddingRight: '24',
    components: [
      {
        id: 'features-2col-row-1',
        type: 'row',
        props: {
          direction: { base: 'horizontal', tablet: null, desktop: null },
          gap: 'lg',
          alignment: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
          columnLayout: { base: 'equal', tablet: null, desktop: null },
          columnWidths: [],
          width: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          maxWidth: { base: { value: '1200', unit: 'px' }, tablet: null, desktop: null },
          padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
          margin: { base: { top: 0, bottom: 0, left: 'auto', right: 'auto', unit: 'px' }, tablet: null, desktop: null },
          backgroundColor: 'transparent',
          backgroundImageUrl: '',
          borderWidth: 0,
          borderStyle: 'solid',
          borderColor: 'transparent',
          borderRadius: 0,
          overflow: 'visible',
          visibility: { base: true, tablet: null, desktop: null },
          position: 'relative',
          top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          zIndex: 'auto',
          customCSS: '',
        },
        children: [
          // Left Column - Image
          {
            id: 'features-2col-col-1',
            type: 'column',
            props: {
              gap: 'md',
              alignItems: 'center',
              justifyContent: 'center',
              span: { base: 12, tablet: 6, desktop: 6 },
              width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
              padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              {
                id: 'features-2col-image-1',
                type: 'image',
                props: {
                  src: 'https://via.placeholder.com/400x300/eeeeee/999999?text=Feature+Image',
                  alt: 'Feature image placeholder',
                  linkUrl: '',
                  openInNewTab: false,
                  width: { base: { value: 100, unit: '%' }, tablet: null, desktop: null },
                  height: { base: { value: 300, unit: 'px' }, tablet: null, desktop: null },
                  maxWidth: { base: { value: 400, unit: 'px' }, tablet: null, desktop: null },
                  objectFit: 'cover',
                  objectPosition: 'center',
                  aspectRatio: 'auto',
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 8,
                  opacity: 100,
                  filter: 'none',
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'static',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [],
              },
            ],
          },
          // Right Column - Content
          {
            id: 'features-2col-col-2',
            type: 'column',
            props: {
              gap: 'md',
              alignItems: 'flex-start',
              justifyContent: 'center',
              span: { base: 12, tablet: 6, desktop: 6 },
              width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
              padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              {
                id: 'features-2col-heading-1',
                type: 'text',
                props: {
                  content: 'Powerful Feature',
                  element: 'h2',
                  fontFamily: 'System Default',
                  fontSize: 32,
                  fontWeight: 'bold',
                  lineHeight: 1.2,
                  letterSpacing: 0,
                  color: '#1a1a1a',
                  textAlign: 'left',
                  textTransform: 'none',
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'static',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [],
              },
              {
                id: 'features-2col-text-1',
                type: 'text',
                props: {
                  content: 'Detailed description of this feature explaining how it helps users accomplish their goals. This section provides more context and information about the benefits.',
                  element: 'p',
                  fontFamily: 'System Default',
                  fontSize: 16,
                  fontWeight: 'normal',
                  lineHeight: 1.6,
                  letterSpacing: 0,
                  color: '#666666',
                  textAlign: 'left',
                  textTransform: 'none',
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'static',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [],
              },
            ],
          },
        ],
      },
    ],
  },
};

export default features2col;
